import withRouter from '@utils/wrappers/WithRouter';
import * as yup from 'yup'; // for everything

import CrudPage from '@modules/cruds/CrudPage';
import getDefaultValue from '../getDefaultValue';
import ItemTypeForm from './ItemTypeForm';
import { IElementType } from '@ts/ui-models';
import { useAppDispatch } from '@redux/store';
import { createLocationRules } from '../Locations/Location.utils';
import { defaultConfigComponent } from './ItemTypes';
import { normalizeCEntity } from '@models/entity/Entity.normalizers';
import { normalizeCElementType } from './normalizer/ItemType.normalizers';

const itemTypeGeneralSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  customId: yup.string().required().label('Custom ID'),
  //flavors: yup.object().required().label('Main Flavor in Settings'),
  lastReadingsConfig: yup.object().nullable(true),
});

const ItemTypePage = props => {
  const dispatch = useAppDispatch();
  const itemId = props.transferPropsRoute.params.id;

  //#region Functions
  const extraActionToDoAfterCorrectSubmit = async (values: IElementType, options: { itemId: string }) => {
    if (!values.flavors?.['location']) {
      return Promise.resolve();
    }
    return createLocationRules(dispatch, props.transferPropsRoute.id, values.flavors['location'].locationRules, options);
  };
  //#endregion

  return (
    <CrudPage
      {...props}
      key={itemId || 'newItemTypeCrud'}
      configComponent={defaultConfigComponent}
      itemId={itemId}
      form={ItemTypeForm}
      defaultValues={getDefaultValue(['elementType'])}
      validationSchema={itemTypeGeneralSchema}
      extraActionToDoAfterCorrectSubmit={extraActionToDoAfterCorrectSubmit}
      normalize={normalizeCElementType<IElementType>}
    />
  );
};

export default withRouter(ItemTypePage);
